export default __webpack_public_path__ + "static/Illustration2-179a7694198293fce0365c7bb74d280b.png";